import { StyleSheet } from 'react-native';
import { TripFlowTheme } from '@/theme/TripFlowTheme';

/**
 * Shared styles for the Value Proposition screen to keep layout consistent
 * and reduce duplication across feature cards and indicators.
 */
export const createValuePropStyles = (theme: TripFlowTheme) =>
  StyleSheet.create({
    screen: {
      flex: 1,
    },
    glassCard: {
      backgroundColor: 'rgba(255, 255, 255, 0.14)',
      borderRadius: theme.radii.xl,
      padding: theme.spacing(2),
      borderWidth: 1.5,
      borderColor: 'rgba(255, 255, 255, 0.28)',
      gap: theme.spacing(1),
      overflow: 'hidden',
      ...theme.shadows.level3,
    },
    iconContainer: {
      width: 40,
      height: 40,
      borderRadius: theme.radii.md,
      backgroundColor: '#132a13',
      justifyContent: 'center',
      alignItems: 'center',
      borderWidth: 1,
      borderColor: 'rgba(255, 255, 255, 0.3)',
    },
    iconContainerSm: {
      width: 32,
      height: 32,
      borderRadius: theme.radii.md,
      backgroundColor: 'rgba(19, 42, 19, 0.6)',
      justifyContent: 'center',
      alignItems: 'center',
      borderWidth: 1.5,
      borderColor: 'rgba(255, 255, 255, 0.35)',
    },
    featureTitle: {
      ...theme.typography.title,
      fontWeight: '800',
      textAlign: 'center',
      color: '#FFFFFF',
      letterSpacing: 0.2,
    },
    featureDescription: {
      ...theme.typography.body,
      textAlign: 'center',
      color: 'rgba(255, 255, 255, 0.95)',
      fontWeight: '500',
    },
    previewContainer: {
      borderRadius: theme.radii.xl,
      borderWidth: 1.5,
      borderColor: 'rgba(255, 255, 255, 0.3)',
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
      overflow: 'hidden',
    },
    screenshot: {
      width: '100%',
      height: '100%',
      resizeMode: 'cover',
    },
    indicatorsRow: {
      flexDirection: 'row',
      gap: theme.spacing(1),
      alignItems: 'center',
      justifyContent: 'center',
    },
    indicatorTapArea: {
      minWidth: 44,
      minHeight: 44,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: theme.spacing(0.5),
    },
    indicatorDot: {
      width: 8,
      height: 8,
      borderRadius: 4,
      backgroundColor: 'rgba(255, 255, 255, 0.4)',
    },
    indicatorDotActive: {
      width: 24,
      backgroundColor: '#FFFFFF',
    },
  });
